const IS_IFRAME = window.self !== window.top;
export default IS_IFRAME;
